<template>
  <div>
    <el-input
      v-if="disabled"
      :value="formName"
      disabled
      style="width: 390px"
      readonly
    />
    <select-dialog
      v-else
      :title="$t('SystemMaintenance.SelectionForm')"
      :row-data="rowData"
      :column-defs="columnDefs"
      :filter-keys="filterKeys"
      :value="formUuid"
      display-name-field="name"
      :event-name="formName"
      :show-branch-select-btn="false"
      @change="changeTrigger"
    />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import SelectDialog from '@/components/SelectDialog'
import { APPLICATION_SCENE, BUSINESS_TYPE } from '@/class/cargo/model/parameters/AiCustomPageConstants'

export default {
  name: 'CustomFormSelectDialog',
  components: { SelectDialog },
  props: {
    lob: { type: String, required: true },
    formUuid: { type: String, default: '' }, // 选中的表单UUID
    formName: { type: String, default: '' }, // 选中的表单名称
    formList: { type: Array, default: () => [] }, // 表单列表
    disabled: { type: Boolean, default: false }, // 是否禁用
    applicationScene: { type: Number, default: null } // 应用场景过滤条件
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_FormName'),
          suppressMenu: true,
          width: 200,
          field: 'name'
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationCompany'),
          suppressMenu: true,
          width: 200,
          field: 'branchId',
          valueFormatter: params => {
            return ColumnUtils.getOfficeLabel('officeId', params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ApplicationScene'),
          suppressMenu: true,
          width: 200,
          field: 'applicationScene',
          valueFormatter: params => {
            const scene = Object.values(APPLICATION_SCENE).find(s => s.value === params.value)
            return scene ? this.$t(scene.key) : this.$t('CargoMsg.Cargo_Unknown')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          suppressMenu: true,
          width: 200,
          field: 'businessType',
          valueFormatter: params => {
            const type = Object.values(BUSINESS_TYPE).find(t => t.value === params.value)
            return type ? this.$t(type.key) : this.$t('CargoMsg.Cargo_Unknown')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          suppressMenu: true,
          field: 'remarks',
          width: 200
        }
      ],
      filterKeys: ['name', 'remarks']
    }
  },
  computed: {
    rowData() {
      let businessType = BUSINESS_TYPE.UNKNOWN.value
      switch (this.lob) {
        case 'SE':
          businessType = BUSINESS_TYPE.SEA_EXPORT.value
          break
        case 'AE':
          businessType = BUSINESS_TYPE.AIR_EXPORT.value
          break
        default:
          break
      }

      let filteredForms = this.formList.filter(form => form.businessType === businessType)

      // 根据应用场景进一步过滤
      if (this.applicationScene !== null) {
        filteredForms = filteredForms.filter(form => form.applicationScene === this.applicationScene)
      }

      return filteredForms
    }
  },
  methods: {
    changeTrigger(data) {
      this.$emit('change', data)
    }
  }
}
</script>
